export { GetStartedBox, type GetStartedBoxProps } from './GetStartedBox';
export { getStartedBoxSchema } from './schema';
